import { useEffect } from "react";

const useKeyboardShortcuts = ({
  mainContainerRef,
  deleteSelectedObject,
  deselectAll,
}) => {
  useEffect(() => {
    const mainEl = mainContainerRef.current;
    if (!mainEl) return;

    const handleKeyDown = (e) => {
      const activeEl = document.activeElement;
      const isInputFocused =
        activeEl && ["INPUT", "TEXTAREA", "SELECT"].includes(activeEl.tagName);

      if (e.key === "Escape") {
        e.preventDefault();
        if (deselectAll) {
          deselectAll();
        } else if (isInputFocused && activeEl instanceof HTMLElement) {
          activeEl.blur();
        } else {
          mainContainerRef.current?.focus();
        }
      }

      // Удаление через клавиатуру отключено - удаление только через кнопку в панели свойств
      // if ((e.key === "Delete" || e.key === "Backspace") && !isInputFocused) {
      //   if (deleteSelectedObject) {
      //     e.preventDefault();
      //     deleteSelectedObject();
      //   }
      // }
    };

    mainEl.addEventListener("keydown", handleKeyDown);
    return () => {
      mainEl.removeEventListener("keydown", handleKeyDown);
    };
  }, [mainContainerRef, deleteSelectedObject, deselectAll]);
};

export default useKeyboardShortcuts;